module.exports = __webpack_public_path__ + "img/login_btn.fa275ec5.svg";